module.exports = __webpack_public_path__ + "static/media/16.7cd34955.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/16.png
// module id = 797
// module chunks = 0